module.exports = __webpack_public_path__ + "img/file-icon.75bfa964.png";